var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 90,
    viewBox: "0 0 88 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1112777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.3241 8.48C54.2424 5.68907 50.5615 5.11993 48.6959 7.45975L30.2748 30.5798L11.8535 53.6998C9.99213 56.0396 11.3421 59.5261 14.2893 59.9814L43.4136 64.4672L72.5378 68.9529C75.485 69.4082 77.8118 66.4824 76.7302 63.6914L66.0313 36.0857L55.3241 8.48Z",
    fill: "#F49E00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.2154 55.9454C44.1615 55.7815 43.3302 55.3063 42.7256 54.5158C42.1209 53.7253 41.8942 52.8381 42.0453 51.8583C42.1965 50.8786 42.6668 50.1133 43.4645 49.5625C44.2623 49.0116 45.1986 48.8182 46.2819 48.9864C47.3652 49.1504 48.2008 49.6171 48.797 50.3824C49.3932 51.1477 49.6157 52.0181 49.4646 52.9978C49.3134 53.9776 48.8348 54.7555 48.0202 55.3315C47.2057 55.9034 46.2693 56.1094 45.2154 55.9454ZM49.0951 46.6023L44.3043 45.8664L45.8117 28L53 29.1017L49.0951 46.6023Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.1429 84.0017C62.6167 84.0017 76.782 83.6664 76.782 83.2528C76.782 82.8392 62.6167 82.5039 45.1429 82.5039C27.6692 82.5039 13.5039 82.8392 13.5039 83.2528C13.5039 83.6664 27.6692 84.0017 45.1429 84.0017Z",
    fill: "#D2E7FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.9875 82.644L56.2495 75.2208C56.2495 75.2208 63.3383 81.4649 63.3383 81.3466C63.3383 81.2284 68.7357 69.3281 68.7357 69.3281C68.7357 69.3281 66.0024 80.486 66.0815 82.1251C66.0815 82.1251 68.8181 79.6452 70.1138 79.4415C71.4096 79.2379 68.3334 81.7703 68.3367 83.2583H61.2743L60.9875 82.644Z",
    fill: "#4CD8BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.793af1b5f77bc9cf0e53441bdeb029b7.svg";
export { ForwardRef as ReactComponent };